"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNotificationDate = formatNotificationDate;
exports.getNotificationPath = getNotificationPath;
var react_router_dom_1 = require("react-router-dom");
var routes_1 = require("../constants/routes");
// Alarms and tasks open their own pages; information-only notifications open the notification itself.
function getNotificationPath(notification) {
    if (notification.link.kind === "ALARM" && notification.link.id) {
        return (0, react_router_dom_1.generatePath)(routes_1.ROUTES.ALARM_VIEW, { id: notification.link.id });
    }
    if (notification.link.kind === "TASK" && notification.link.id) {
        return (0, react_router_dom_1.generatePath)(routes_1.ROUTES.TASK_VIEW, { id: notification.link.id });
    }
    return (0, react_router_dom_1.generatePath)(routes_1.ROUTES.NOTIFICATION_VIEW, { id: notification.id });
}
function formatNotificationDate(createdAt) {
    return new Date(createdAt).toLocaleString("en-ZA", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}
